import React from "react";
import GoogleReviews from "./GoogleReviews";

// Section « Ils nous font confiance » : preuve sociale = les 5 avis Google réels.
// (L'ancienne marquee de logos de marques et le titre
// « Les accessoires choisis par les amateurs de tech » ont été retirés.)
const TrustedBy = () => {
    return (
        <section className="relative py-16 md:py-24 bg-[#F5F5F7] border-y border-black/[0.06]">
            <div className="max-w-[1320px] mx-auto px-6 md:px-10">
                <div className="text-center">
                    <div className="dp-eyebrow">Ils nous font confiance</div>
                </div>

                {/* Avis Google réels (5,0★ · 9 avis) — affichage visuel uniquement,
                    volontairement sans JSON-LD aggregateRating/Review. */}
                <GoogleReviews />
            </div>
        </section>
    );
};

export default TrustedBy;
